module.exports = __webpack_public_path__ + "static/media/ic_addElement.168a2f7a.svg";